"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timeline = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var TimelineLabel = function (props) {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('relative') },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('br-ml-2'), style: { transform: 'translateX(-50%)' } }, props.children)));
};
var Timeline = function (_a) {
    var children = _a.children, isLast = _a.isLast, isFirst = _a.isFirst, _b = _a.showPoint, showPoint = _b === void 0 ? true : _b, labelBottom = _a.labelBottom, labelTop = _a.labelTop, labelCenter = _a.labelCenter, isDotted = _a.isDotted;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('br-flex', 'br-items-stretch') },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('br-flex', 'br-flex-col', 'br-justify-center', 'br-items-start', 'br-w-8', 'br-shrink-0') },
            labelTop && react_1.default.createElement(TimelineLabel, null, labelTop),
            (showPoint || labelCenter) && (react_1.default.createElement("div", { className: (0, classnames_1.default)('br-flex', 'br-grow', 'br-ml-2') },
                react_1.default.createElement("div", { className: (0, classnames_1.default)({ 'br-border-l-4': !isFirst }, { 'br-border-solid': !isDotted }, { 'br-border-dotted': isDotted }, 'br-border-blue-600') }))),
            showPoint && !labelCenter && (react_1.default.createElement("div", { 
                // NOTE: use scale to close gap between border tips and round point element.
                style: { transform: 'scale(1.1)' }, 
                // Only the last circle in the timeline is fully filled in to logically signify the end point.
                className: (0, classnames_1.default)('br-w-3', 'br-h-3', 'br-ml-1', 'br-rounded-full', {
                    'br-bg-blue-600': isLast,
                    'br-bg-white': !isLast,
                    'br-border-blue-600': !isLast,
                    'br-border-4': !isLast
                }) })),
            labelCenter && react_1.default.createElement(TimelineLabel, null, labelCenter),
            react_1.default.createElement("div", { className: (0, classnames_1.default)('br-flex', 'br-grow', 'br-ml-2') },
                react_1.default.createElement("div", { className: (0, classnames_1.default)({ 'br-border-l-4': !isLast }, 'br-border-blue-600', { 'br-border-solid': !isDotted }, { 'br-border-dotted': isDotted }) })),
            labelBottom && react_1.default.createElement(TimelineLabel, null, labelBottom)),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('br-py-1', 'br-w-full', 'br-min-w-0') }, children)));
};
exports.Timeline = Timeline;
